module.exports = __webpack_public_path__ + "static/media/group-12.b320a3a6.png";